<template>
  <div>
    <div id="collection_point">
      <router-link to="/point" id="collect_btn" class="btn--pill blue">
      集點功能
      </router-link>
    </div>
    <portlet class="students_content_area">
      <template slot="header">
        <div class="row">
          <div class="col-12 d-none d-sm-block">
            <navigation
              :list="tabs1"
              :active-value="activeTab"
              variety="portlet-header"
              @active:updated="tapNavigation"
            />
          </div>
          <div class="col-12 d-none d-sm-block">
            <navigation
              :list="tabs2"
              :active-value="activeTab"
              variety="portlet-header"
              @active:updated="tapNavigation"
            />
          </div>
          <div class="col-12 d-sm-none">
            <navigation
              :list="tabs"
              :active-value="activeTab"
              variety="portlet-header"
              @active:updated="tapNavigation"
            />
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="row justify-content-center pt-4 pb-4">
          <bootstrap-pagination
            v-if="pageGetter.page_total > 1"
            :total-page-number="pageGetter.page_total"
            @number:updated="updateRecords"
          />
        </div>
      </template>
      <component
        :is="activeTabComponent"
        ref="content"
      />
    </portlet>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Portlet from '~components/common/Portlet'
import BootstrapPagination from '~bootstrap/Pagination'
import Navigation from '~components/common/Navigation'
import EnrolledCareerCounselling from './EnrolledCareerCounselling'
import EnrolledIndustryMentors from './EnrolledIndustryMentors'
import EnrolledLectures from './EnrolledLectures'
import EnrolledWorkshop from './EnrolledWorkshop'
import EnrolledRecruitment from './EnrolledRecruitment'
import EnrolledInternship from './EnrolledInternship'
import EnrolledEnterpriseVisits from './EnrolledEnterpriseVisits'
export default {
  name: 'EnrolledHistory',
  components: {
    Portlet,
    BootstrapPagination,
    Navigation,
    EnrolledCareerCounselling,
    EnrolledIndustryMentors,
    EnrolledLectures,
    EnrolledWorkshop,
    EnrolledRecruitment,
    EnrolledInternship,
    EnrolledEnterpriseVisits
  },
  data () {
    return {
      tabs1: ['職涯諮詢', '業師諮詢', '職涯講座', '工作坊'],
      tabs2: ['徵才說明會', '實習說明會', '企業參訪'],
      tabs: ['職涯諮詢', '業師諮詢', '職涯講座', '工作坊', '徵才說明會', '實習說明會', '企業參訪'],
      tabComponents: [EnrolledCareerCounselling, EnrolledIndustryMentors, EnrolledLectures, EnrolledWorkshop, EnrolledRecruitment, EnrolledInternship, EnrolledEnterpriseVisits],
      activeTab: '職涯諮詢'
    }
  },
  computed: {
    ...mapGetters('pages/students', [
      'pageGetter'
    ]),
    activeTabComponent () {
      return this.tabComponents[this.tabs.indexOf(this.activeTab)]
    }
  },
  created () {
    const specificSegment = this.$route.query.sub
    if (specificSegment) {
      this.updateActiveTab(specificSegment)
    }
  },
  methods: {
    pushTabQuery (sub) {
      this.$router.push({
        path: '/students',
        query: {
          tab: '活動紀錄',
          sub
        }
      })
    },
    updateActiveTab (sub) {
      this.activeTab = sub
    },
    tapNavigation (sub) {
      this.updateActiveTab(sub)
      this.pushTabQuery(sub)
    },
    updateRecords (page) {
      this.$refs.content.getPage(page)
    }
  }
}
</script>
<style lang="scss" scoped>
#collect_btn {
  line-height: 35px;
  
  @media (min-width: 768px) {
    top: -50px;
    right: 0;
  }
  
  @media (max-width: 768px) { display: inline-block; }
}
</style>